// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"8ec4599d","124":"49f9cd69"}[chunkId] + ".chunk.css";
};